import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getHaloUser, listHaloUsers, triggerHaloUserSync } from './api'

export const haloUserKeys = {
  all: ['halocrm-users'] as const,
  list: (active: boolean, search: string, offset: number, limit: number) =>
    ['halocrm-users', 'list', active, search, offset, limit] as const,
  detail: (id: number) => ['halocrm-users', 'detail', id] as const,
}

export function useHaloUsers(params: {
  active?: boolean
  search?: string
  offset?: number
  limit?: number
}) {
  const active = params.active ?? true
  const search = params.search?.trim() ?? ''
  const offset = params.offset ?? 0
  const limit = params.limit ?? 50
  return useQuery({
    queryKey: haloUserKeys.list(active, search, offset, limit),
    queryFn: () => listHaloUsers({ active, search, offset, limit }),
    // Lokalna kopia odswiezana co 6h przez backend cron - 60s stale-time wystarczy.
    staleTime: 60_000,
  })
}

export function useHaloUser(id: number | null | undefined) {
  return useQuery({
    queryKey: haloUserKeys.detail(id ?? -1),
    queryFn: () => getHaloUser(id as number),
    enabled: typeof id === 'number' && id > 0,
    staleTime: 5 * 60_000,
  })
}

export function useTriggerHaloUserSync() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: triggerHaloUserSync,
    onSuccess: () => qc.invalidateQueries({ queryKey: haloUserKeys.all }),
  })
}
